<template>
  <form class="a-btn" variant="primary">
    資料を添付する
    <!-- <span v-if="!isUpload">資料を添付する</span> -->
    <b-button class="remove" v-if="isComplete" variant="outline-secondary" @click.stop="removeAllFiles">削除する</b-button>
  </form>
  <!-- <form class="dropzone">
    <b-button class="a-btn">資料を添付する</b-button>
  </form> -->
</template>

<script>
import Dropzone from 'dropzone'
import '../../../node_modules/dropzone/dist/dropzone.css'
import apig from '@/apig'
import store from '@/store'

Dropzone.autoDiscover = false

export default {
  name: 'dropzone_problem',
  props: [ 'smartthonId' ],
  data () {
    return {
      isUpload: false,
      isComplete: false,
      isError: false
    }
  },
  computed: {
    smartthon () {
      return store.getters.smartthon
    }
  },
  methods: {
    removeAllFiles () {
      this.dropzone.removeAllFiles()
      this.isUpload = false
      this.isComplete = false
      this.isError = false
      this.$emit('data', {
        type: 'prb',
        isUpload: this.isUpload,
        isComplete: this.isComplete,
        isError: this.isError
      })
    },
    uploadFile () {

    }
  },
  mounted () {
    const vm = this

    let options = {
      // The URL will be changed for each new file being processing
      url: '/',

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      maxFiles: 10,
      dictMaxFilesExceeded: 'アップロードは1ファイルのみです',
      acceptedFiles: 'application/pdf',
      dictInvalidFileType: 'アップロードはpdfファイルのみです',
      maxFilesize: 15.0,
      dictFileTooBig: 'アップロードは15MBまでです。',

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // Customize the wording
      dictDefaultMessage: '',

      previewTemplate: '<div style="display:none"></div>',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        vm.isUpload = true
        vm.$emit('data', {
          type: 'prb',
          isUpload: vm.isUpload
        })
        let additionalParams = {
          queryParams: {
            type: 'smartthon_prb',
            smartthonId: vm.smartthonId
          }
        }
        apig.getSignedURL(file, additionalParams)
          .then((res) => {
            file.uploadURL = res.data.url
            done()

            setTimeout(() => {
              vm.dropzone.processFile(file)
              vm.isComplete = true
              vm.$emit('data', {
                type: 'prb',
                isComplete: vm.isComplete,
                name: file.name,
                attachmentId: res.data.uuid
              })
            })
          })
          .catch((err) => {
            console.log(err)
            vm.isError = true
            vm.$emit('data', {
              type: 'prb',
              isError: vm.isError
            })
            done('アップロードに失敗しました', err)
          })
      }
    }

    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, options)

    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })
  }
}
</script>

<style lang="stylus" scoped>
primaryBlue = #3498db

.dropzone
  padding 0

.a-btn
  color #ffffff
  text-align center
  width 200px
  position absolute
  top 4px
  right 6px
  padding 4px 50px
  cursor pointer

.remove
  text-align center
  width 200px
  position absolute
  top -1px
  right -1px
  padding 4px 50px
  background-color #ffffff
  border-color #6c757d
  border-radius 50px
  box-shadow 0 4px 12px rgba(0,0,0,.15)
  font-size 14px
  font-weight 700
  &:hover
    background-color #6c757d

form.dropzone
  transition all 0.2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  &:hover
    border-color primaryBlue
    .dz-message
      .dropzone-title
        color primaryBlue
  .dz-message
    color #666
    height 400px
    display -webkit-flex
    display flex
    -webkit-align-items center
    align-items center
    -webkit-justify-content center
    justify-content center
    span
      line-height 1.8
      font-size 13px
      letter-spacing 0.4px
      span.dropzone-title
        display block
        color #888
        font-size 1.25em
      span.dropzone-info
        display block
        color #a8a8a8

</style>



// WEBPACK FOOTER //
// src/components/share/dropzone_problem.vue